module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA2CAMAAADnEdnLAAAAM1BMVEX////ljjjyy67srnvvvZb55tn9+fbqpm3nlkv67OPonl388+ztton12cTxxKL00rn3389rxx53AAAAsUlEQVR4Xu3Ty2oDMQxAUV3Jz8dM8v9f2yBoV7IXKdnlbK+FsMHyYV/XMluPEsdScTXuN4ykBinMlTZFZFAl1v0UJltFQXcRgFROue1zzo8FJgcDehDmdT/lRSEHOcOY/nYtXG5AXQ1uiRTDWZFY15cuHzCv/Evji/2Js7m6y+LyLqtLcNz93vQ47VbGaVrPuw07TBe4DrsV5j73hnnTZ6JF/697hvAPpoc4M1tT/uPrBxMaA/4isWBCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/pin_mar.png
// module id = 1691
// module chunks = 1